<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link :to="{ name: 'EXCMDeviceStateCreate', params: { idDevice: idDevice } }" class="mb-1 btn btn-sm btn-primary float-right">{{$t('buttons.create')}}</router-link>
    </template>
    <template #filtering>
      <div class="float-right">
        <button type="button"
                class="btn btn-sm fa fa-sync fa-lg btn-link"
                @click="clearFilters()">
        </button>
        <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.devices_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="devices_search_collapse" class="mt-2">
          <DeviceStateFiltering ref="deviceFiltering" :idDevice="idDevice" :getPage="getPage"></DeviceStateFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <div v-else-if="!isLoading && items.length < 1">{{ $t('views.excmdevicestate.list.noexcmdevicestates') }}</div>
      <EXCMDeviceStatesTable v-else :items="items" :display-device-column="!idDevice"/>
      <div v-if="view">
        <pagination
          :view="view"
          @getPage="getPage($event)"
        ></pagination>
      </div>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import DeviceStateFiltering from './components/DeviceStateFiltering/DeviceStateFiltering'
import Loader from '../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Pagination from '../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import EXCMDeviceStatesTable from '@/components/Dashboard/Views/excmdevicestate/EXCMDeviceStatesTable'
import getId from '@/utils/getIdFromLink'

export default {
  components: {
    EXCMDeviceStatesTable,
    DeviceStateFiltering,
    Loader,
    Pagination,
    BaseTableWrapper
  },

  props: {
    idDevice: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      deletedItem: 'excmdevicestate/del/deleted',
      error: 'excmdevicestate/list/error',
      items: 'excmdevicestate/list/items',
      isLoading: 'excmdevicestate/list/isLoading',
      view: 'excmdevicestate/list/view'
    })
  },

  data () {
    return {
      searchParams: {
        state: 1,
        idDevice: this.idDevice
      }
    }
  },

  beforeCreate () {
    checkPagePermission('devices', 'EXCMDeviceStateList')
  },

  created () {
    let url = addParamsToQuery('e_x_c_m_device_states?order[readDate]=DESC', this.searchParams)
    this.getPage(url)
    this.channelexcmdevicestatesrooms = this.$store.state.Pusher.subscribe('e_x_c_m_device_states')
    this.channelexcmdevicestatesrooms.bind('e_x_c_m_device_states', data => {
      this.getPage(url)
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_device_states')
  },

  methods: {
    ...mapActions({
      getPage: 'excmdevicestate/list/default'
    }),
    getIdLink (link) {
      return getId(link)
    },
    clearFilters () {
      this.$refs.deviceFiltering.clearFilters()
    }
  }
}
</script>
